import React from 'react';
import { Header } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';

const ScheduleAvailability = ({ availableDays, startTime, endTime }) => {
  const alwaysAvailable = availableDays.length === 1 && availableDays[0] === 'ALL';

  if (alwaysAvailable) return <div />;

  return (
    <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
      <Header as="h5" style={{ marginBottom: 0 }}>
        Available On:
      </Header>
      <div as="h6">
        {availableDays.map((day, index) => (
          <span key={day}>
            {_.startCase(day.toLowerCase())}
            {index === availableDays.length - 1 ? '' : ', '}
          </span>
        ))}
        <span> from </span>
        <span>{moment(startTime, 'HH:mm').format('h:mm A')}</span>
        <span> to </span>
        <span>{moment(endTime, 'HH:mm').format('h:mm A')}</span>
      </div>
    </div>
  );
};

export default ScheduleAvailability;
